export default __webpack_public_path__ + "static/media/scripting-selected.10f9fe95.svg";